import { StandaloneFrontCoverstoryProps } from '@/elle/components/FrontCoverstory';
import { StandaloneComponent } from '@/types/component';

// Elle specific component

const FrontCoverstory: StandaloneComponent<StandaloneFrontCoverstoryProps> = () => null;

export default FrontCoverstory;
